<template>
  <div class="row">
    <div class="col-md-12">
      <div class="download-list">
        <ChildAccount
          v-for="(account, index) in accounts"
          :key="index"
          :account="account"
        ></ChildAccount>
      </div>
    </div>
  </div>
</template>

<script>
import ChildAccount from "@/views/Billing/Components/ChildAccount.vue";

export default {
  name: "ChildAccounts",
  props: {
    accounts: {
      type: Array,
      required: true
    }
  },
  components: {
    ChildAccount
  }
};
</script>
